import Hero from "../components/Hero";
import React, { useState, useEffect } from 'react';
import BookCar from "../components//BookCar.jsx";
import Loader from "./Loader";

import Banner from "../components/Banner";
import Bannerz from "../components/clientbanner";
import ChooseUs from "../components/ChooseUs";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
//import Models from "./Models";
import { Helmet } from "react-helmet";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Faq2 from "../components/Faq2.jsx";
//const stripePromise = loadStripe("pk_test_51HXXdHFG78dEXAMPLEPUBLICKEYY4Nh");


function Home() {

  const [showDelayedComponents, setShowDelayedComponents] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDelayedComponents(true);
    }, 2500);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);



  return (
    <>
      <Helmet>
        <title>
        Home - Bulls Eye Car Rental
        </title>

        <meta
          name="description"
          content="Welcome to Bulls Eye Car Rental, your trusted choice for car and scooter rentals in Freeport, Grand Bahama. Established in 2014, we provide reliable vehicles, excellent customer service, and competitive prices to make your travel seamless and enjoyable. Book with us today!"
        />
        {/* Add more meta tags as needed */}
      </Helmet>
      <Loader />
      <Hero />

      

      <BookCar/>
      

      <ChooseUs />
      
      <Bannerz/>

      <Testimonials />
      {showDelayedComponents && (
         <>

      <Banner />
      <Faq />
       <Faq2 />
      <Footer />
      </>
    )}
      
    </>
  );
}

export default Home;
